export const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
